import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export type TCreateBudgetDocumentSection = {
    documentId: string;
    params: {
        session_title: string;
        type: string;
        content: string;
        position: number;
    };
};

export type TCreateDocumentByIdResponse = {
    data: any;
};

export default async ({ documentId, params }: TCreateBudgetDocumentSection) => {
    const content = params.type !== "texto" ? params.type : params.content;
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/session/${documentId}`,
        method: "post",
        headers: { auth: true },
        body: { ...params, content },
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TCreateDocumentByIdResponse>({
        body,
        statusCode,
    });
};
